(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ariane-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.currentScript.closest('.shopify-section') || document.currentScript.parentElement;
  if (!section) return;

  var slider = section.querySelector('.slider');
  if (!slider) return;

  var slides = slider.querySelectorAll('.slide');
  var dots = slider.querySelectorAll('.dot');
  var nextBtn = slider.querySelector('.next-btn');

  if (!slides.length) return;

  var index = 0;

  function showSlide(newIndex) {
    if (newIndex < 0) newIndex = slides.length - 1;
    if (newIndex >= slides.length) newIndex = 0;

    slides[index].classList.remove('active');
    if (dots[index]) dots[index].classList.remove('active');

    index = newIndex;

    slides[index].classList.add('active');
    if (dots[index]) dots[index].classList.add('active');
  }

  function nextSlide() {
    showSlide(index + 1);
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', nextSlide);
  }

  dots.forEach(function(dot, dotIndex) {
    dot.addEventListener('click', function() {
      showSlide(dotIndex);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
